import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ProductTexts } from '../contexts/LangProducts2';

// 제품 이미지 임포트 (필요에 따라 수정)
import haycyonImg from '../assets/images/halcyon.png';
import primxImg from '../assets/images/primx.png';
import kosmosImg from '../assets/images/1kosmos.png';
import proofpointImg from '../assets/images/proofpoint.png';
import mobileumImg from '../assets/images/mobileum.png';

function Products2({ lang = 'ko' }) {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [activeProduct, setActiveProduct] = useState(0);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // 제품 데이터
  const products = [
    {
      id: 'halcyon',
      name: ProductTexts.Halcyon.title[lang],
      image: haycyonImg,
      description: ProductTexts.Halcyon.message[lang],
      route: '/product/halcyon',
      color: '#4A90E2'
    },
    {
      id: 'primx',
      name: ProductTexts.Primxtitle.title[lang],
      image: primxImg,
      description: ProductTexts.Primxtitle.message[lang],
      route: '/product/primx-zc',
      color: '#50C878'
    },
    // {
    //   id: '1kosmos',
    //   name: ProductTexts.Kosmos.title[lang],
    //   image: kosmosImg,
    //   description: ProductTexts.Kosmos.message[lang],
    //   route: '/product/1kosmos',
    //   color: '#FF6B6B'
    // },
    {
      id: 'proofpoint',
      name: ProductTexts.ObserveIT.title[lang],
      image: proofpointImg,
      description: ProductTexts.ObserveIT.message[lang],
      route: '/product/proofpoint-oit',
      color: '#9B59B6'
    },
    // {
    //   id: 'Mobileum',
    //   name: ProductTexts.Mobileum.title[lang],
    //   image: mobileumImg,
    //   description: ProductTexts.Mobileum.message[lang],
    //   route: '/product/mobileum',
    //   color: '#FF6B6B'
    // },
  ];

  return (
    <section
      style={{
        width: '100%',
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        padding: isMobile ? '40px 20px' : '80px 40px',
        boxSizing: 'border-box'
      }}
    >
      {/* 헤더 섹션 */}
      <div style={{ maxWidth: '1200px', margin: '0 auto', marginBottom: '60px' }}>
        <h1
          style={{
            fontSize: isMobile ? '2.2rem' : '3rem',
            fontWeight: '800',
            color: '#fff',
            textAlign: 'center',
            marginBottom: '20px',
            textShadow: '0 4px 8px rgba(0,0,0,0.3)'
          }}
        >
          {ProductTexts.Product.title[lang]}
        </h1>
        <p
          style={{
            fontSize: isMobile ? '1.1rem' : '1.3rem',
            color: '#f8f9fa',
            textAlign: 'center',
            lineHeight: '1.6',
            maxWidth: '900px',
            margin: '0 auto',
            opacity: '0.9'
          }}
        >
          {ProductTexts.Product.subtitle[lang]}
        </p>
      </div>

      {/* 제품 그리드 */}
      <div
        style={{
          maxWidth: '1400px',
          margin: '0 auto',
          display: 'grid',
          gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)',
          gap: isMobile ? '30px' : '25px'
        }}
      >
        {products.map((product, index) => (
          <ProductCard
            key={product.id}
            product={product}
            isActive={activeProduct === index}
            onHover={() => setActiveProduct(index)}
            onClick={() => navigate(product.route)}
            isMobile={isMobile}
            lang={lang}
          />
        ))}
      </div>
    </section>
  );
}

// 개별 제품 카드 컴포넌트
function ProductCard({ product, isActive, onHover, onClick, isMobile, lang = 'ko' }) {
  return (
    <div
      style={{
        background: 'rgba(255, 255, 255, 0.95)',
        borderRadius: '20px',
        padding: isMobile ? '35px 25px' : '45px 35px',
        boxShadow: isActive
          ? '0 20px 40px rgba(0,0,0,0.2)'
          : '0 10px 30px rgba(0,0,0,0.1)',
        cursor: 'pointer',
        transition: 'all 0.4s ease',
        transform: isActive ? 'translateY(-5px)' : 'translateY(0)',
        border: `3px solid ${isActive ? product.color : 'transparent'}`,
        position: 'relative',
        overflow: 'hidden'
      }}
      onMouseEnter={onHover}
      onClick={onClick}
    >
      {/* 배경 그라데이션 */}
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: '6px',
          background: `linear-gradient(90deg, ${product.color}, ${product.color}88)`,
          opacity: isActive ? 1 : 0.7,
          transition: 'opacity 0.3s ease'
        }}
      />

      {/* 제품 이미지 */}
      <div
        style={{
          textAlign: 'center',
          marginBottom: '25px'
        }}
      >
        <img
          src={product.image}
          alt={product.name}
          style={{
            width: isMobile ? '90px' : '120px',
            height: isMobile ? '90px' : '120px',
            objectFit: 'contain',
            filter: isActive ? 'none' : 'grayscale(20%)',
            transition: 'filter 0.3s ease'
          }}
        />
      </div>

      {/* 제품명 */}
      <h3
        style={{
          fontSize: isMobile ? '1.2rem' : '1.3rem',
          fontWeight: '700',
          color: '#2c3e50',
          marginBottom: '15px',
          lineHeight: '1.3',
          textAlign: 'center'
        }}
      >
        {product.name}
      </h3>

      {/* 설명 */}
      <p
        style={{
          fontSize: '1rem',
          color: '#5a6c7d',
          lineHeight: '1.6',
          marginBottom: '20px',
          minHeight: '280px',
          overflow: 'hidden',
          display: '-webkit-box',
          WebkitLineClamp: 12,
          WebkitBoxOrient: 'vertical'
        }}
      >
        {product.description}
      </p>

      {/* 자세히 보기 버튼 */}
      <button
        style={{
          width: '100%',
          padding: '12px 0',
          background: product.color,
          color: '#fff',
          border: 'none',
          borderRadius: '10px',
          fontSize: '1rem',
          fontWeight: '600',
          cursor: 'pointer',
          transition: 'all 0.3s ease',
          opacity: isActive ? 1 : 0.9
        }}
        onMouseEnter={(e) => {
          e.target.style.transform = 'scale(1.02)';
        }}
        onMouseLeave={(e) => {
          e.target.style.transform = 'scale(1)';
        }}
      >
        {ProductTexts.Detailbtn[lang]}
      </button>
    </div>
  );
}

export default Products2;